import { render } from "./PostNotification.vue?vue&type=template&id=01283643&scoped=true"
import script from "./PostNotification.vue?vue&type=script&lang=js"
export * from "./PostNotification.vue?vue&type=script&lang=js"

import "./PostNotification.vue?vue&type=style&index=0&id=01283643&scoped=true&lang=scss"

import exportComponent from "/var/www/mbp-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01283643"]])

export default __exports__